import { render, staticRenderFns } from "./kindChooseViewktypevip.vue?vue&type=template&id=a7a7c460&scoped=true"
import script from "./kindChooseViewktypevip.vue?vue&type=script&lang=js"
export * from "./kindChooseViewktypevip.vue?vue&type=script&lang=js"
import style0 from "./kindChooseViewktypevip.vue?vue&type=style&index=0&id=a7a7c460&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a7c460",
  null
  
)

export default component.exports